<template>
  <div
      class="flex flex-col items-start justify-center w-64 border-2 border-gray-400 p-8 rounded-lg bg-gray-100"
      v-if="isSingle"
  >
    <!-- Überschrift ist übersetzter Label aus dem übergebenen Filter -->
    <h3 class="label-title" v-if="showtitle">{{ _t(filter.label) }}</h3>
    <check-box
        ref="multicheckbox"
        @update:checked="check(filter.value, filter.namespace, $event)"
        @input="checked = $event.target.checked"
        :fieldId="getFieldId(prefix, filter.id)"
        :valued="getValue(filter.value)"
        :label="_t(filter.label)"
        :className="filter.class"
        :key="filter.key"
        :namespace="filter.namespace"
        :showlabel="showlabel"
    />
  </div>
  <div

      :className="classouter()"
      v-else
  >
    <!-- Überschrift ist übersetzter Label aus dem übergebenen Filter -->
    <h3 class="label-title" v-if="showtitle">{{ _t(filter.label) }}</h3>
    <check-box
        ref="multicheckbox"
        v-for="option in filter.options"
        @update:checked="check(option.value, filter.namespace, $event)"
        @input="checked = $event.target.checked"
        :fieldId="getFieldId(prefix, option.id)"
        :label="_t(option.label)"
        :className="option.class"
        :valued="getValue(option.value)"
        :namespace="filter.namespace"
        :key="option.key"
        :showlabel="showlabel"

    />
  </div>
</template>
<script>
import Checkbox from "@/components/check-box";

export default {
  emits: ["update:value"],
  props: {
    _t: {
      type: Function
    },
    valued: {
      type: String,
      required: false,
      default: '',
    },
    prefix: {
      type: String,
      required: false,
      default: '',
    },
    outerclass: {
      type: String,
      required: false,
      default: 'flex flex-col items-start justify-center w-64 border-2 border-gray-400 p-8 rounded-lg bg-gray-100',
    },
    filter: {
      type: Object,
      required: true,
    },
    showtitle: {
      type: Boolean,
      default: true
    },
    showlabel: {
      type: Boolean,
      default: true
    },
    isSingle: {
      type: Boolean,
      default: false
    },
  },

  setup(props, context) {

    const classouter = () => {
      return props.outerclass
    };

    const getFieldId = (p, c) => {
      var prefix = !p ? '' : p.toString() + '-'
      var cl = !c ? '' : c.toString()
      return 'cb-' + prefix + cl
    };
    const getValue = (v) => {
      if (v === undefined) {
        return ""
      }
      return v.toString()
    };
    const getFilter = () => {
      return props.filter
    };
    /**
     * Verarbeitet nach dem Klick des Users eine gecheckte|geuncheckte Option
     * @param {string} optionValue Wert der Option
     * @param {string} namespace Namespace des betroffenen Filters
     * @param {boolean} checked Ist die Option gecheckt?
     */
    const check = (optionValue, namespace, checked) => {
      // filter.queries hält ein Array der aktuellen Filter-Werte der zu filternden Artikeleigenschaft

      let updatedValue = [...props.filter.queries];

      if (checked) {
        // Es gibt multiple Werte. Diese sind durch | getrennt (z.B. brand Titanflex: 'EBT|BR|EBO')
        // Es wird also immer ein Array aus dem String updatedValue erzeugt
        if (typeof optionValue !== "boolean") {
          optionValue = optionValue.split('|')
          updatedValue = updatedValue.concat(optionValue);
        } else {
          updatedValue = optionValue;
        }
      } else {
        if (typeof optionValue !== "boolean") {
          let values =  new Set(optionValue.split('|'));
          // Filter-Werte aus dem Filter entfernen
          updatedValue = updatedValue.filter(
              value => {
                return !values.has(value)
              }
          )
        } else {
          updatedValue = ''
        }
      }
      // Die Methode onMultiCheckboxChange in App.vue wird nun die neuen Filter-Werte in den Filter übernehmen
      context.emit("update:value", updatedValue, namespace);
    };

    return {
      check,
      getFieldId,
      classouter,
      getFilter,
      getValue
    };

  },
  components: {
    "check-box": Checkbox,
  },

  mounted() {
    let self = this
    const timeWas = new Date();

    const wait = setInterval(function() {
      if(self.filter && Object.hasOwn(self.filter,'queries') && self.filter.queries.length) {

        for(const element of  self.$el.getElementsByTagName('input') ) {
          if(self.filter.queries.includes(element.getAttribute("data-value")) || self.filter.type == 'single') {
            element.checked = true
          }
        }
        clearInterval(wait);
      } else if (new Date() - timeWas > 2000) { // Timeout
        clearInterval(wait);
      }
    }, 100);
  }
};
</script>